import React from "react";


function Accommodation() {
    return (
        <div>
            <div className="row banner" style={{ backgroundImage: 'url(./images/g_1.jpeg)', backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
            <div className="container" style={{ marginTop: '100px', marginBottom: '100px' }}>
                <h3 style={{ fontWeight: '600', fontSize: '14pt', lineHeight: '24pt', color: 'maroon' }}>
                    Thirunelli Devaswom having a Rest House (Panchatheertham Guest House) with ample facilities for the convenient stay of devotees. The rooms can be booked in advance.
                </h3>
                <hr />
                {/* <h3 style={{ marginBottom: '25px', fontWeight: '600' }}>CHECKOUT Time : 1 PM</h3> */}
                <div className="row">
                    <div className="col-md-6" style={{ background: '#fad096', padding: '50px' }}>
                        {/* <div className="row" style={{ marginBottom: '50px', borderBottom: '1px solid orange', paddingBottom: '15px', paddingTop: '15px', background: 'orange' }}>
                            <div className="col-md-7 middle">
                                <p className="enquiry">For Enquiry & Booking</p>
                            </div>
                            <div className="col-md-5 middle">
                                <p className="phone">0471 2472086</p>
                            </div>
                        </div> */}
                        <div className="row" style={{ marginBottom: '10px', borderBottom: '1px solid orange', paddingBottom: '15px', paddingTop: '15px' }}>
                            <h3 className="heading">Room Tariff</h3>
                            <table class="table" style={{ background: 'maroon' }}>
                                <tr>
                                    <td>A/c Double Room</td>
                                    <td>Rs. 600/- Per Day</td>
                                </tr>
                                <tr>
                                    <td>Double Room</td>
                                    <td>Rs. 400/- Per Day</td>
                                </tr>
                                <tr>
                                    <td>Reservation Charge</td>
                                    <td>Rs.10/- Per Room</td>
                                </tr>
                            </table>
                            <ol style={{background:'white',padding:'25px 35px 25px 50px',color:'maroon'}}>
                                <li>Extra Person Rs.30/- Person (More than 2 Person in a room)</li>
                                <li>Maximum 4 Person a room in a room including extra person</li>
                            </ol>
                            <p style={{color:'maroon',fontWeight:'600'}}>Check Out Time: 1 PM</p>
                            <table class="table" style={{ background: 'maroon' }}>
                                <tr>
                                    <td>Email</td>
                                    <td>accomodation@thirunellitemple.in</td>
                                </tr>
                                <tr>
                                    <td>Devaswom office </td>
                                    <td>04935293201, Mob: 8547336201</td>
                                </tr>
                                <tr>
                                    <td>Rest House</td>
                                    <td>04935210055, Mob: 8547244055</td>
                                </tr>
                            </table>
                        </div>


                    </div>
                    <div className="col-md-6" style={{}}>
                        <img src="./images/g_1.jpeg" alt="Guest House" style={{ width: '100%' }} /> <br />
                        <img src="./images/g_2.jpeg" alt="Guest House" style={{ width: '100%' }} /> <br />
                        <img src="./images/g_3.jpeg" alt="Guest House" style={{ width: '100%' }} /> <br />
                    </div>
                </div>


            </div>
        </div>
    );
}

export default Accommodation;